import { createContext, useEffect, useState } from "react";

export const PlacementReportContentContext = createContext();

const initialReportContentState = {
  placementActivities: "",
};

export const PLACEMENT_ACTIVITIES = "placementActivities";

export const PlacementReportContentContextProvider = ({ children }) => {
  const [content, setContent] = useState(initialReportContentState);

  const setSubTitle = (subTitle, subTitleContent) => {
    setContent((content) => {
      const newContent = {
        ...content,
      };
      newContent[subTitle] = subTitleContent;
      return newContent;
    });
  };

  const getSubTitle = (subTitle) => {
    return content[subTitle];
  };

  useEffect(() => {
    // Get the content from the backend and use setContent to set the same
    console.log(content);
  }, [content]);

  return (
    <PlacementReportContentContext.Provider
      value={{ content, setContent, setSubTitle, getSubTitle }}
    >
      {children}
    </PlacementReportContentContext.Provider>
  );
};
